import React, { useContext, useEffect, useState } from "react";

import axios from "axios";
import { baseServiceUrl, urls } from "../../environment";
import toast from "react-hot-toast";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import useUserStore from "../../stores/useUserStores";

interface Exam {
  id: number;
  title: string;
  description: string;
  status: string;
  duration: number;
  created_by: number;
  created_on: string;
  updated_by: number;
  updated_on: string;
  category: string;
  instructions: string;
  total_marks: number;
  total_questions: number;
  exam_start_time: string;
  exam_end_time: string;
}

interface ExamResult {
  user_id: number;
  email: string;
  phone: string;
  full_name: string;
  title: string;
  total_questions: number;
  total_marks: number;
  obtain_masrk: number;
  correct_count: number;
  incorrect_count: number;
}

const ExamList: React.FC = () => {
  const { token, setLoading } = useUserStore();
  const [List, setList] = useState<Exam[]>([]);
  const [selectedExam, setSelectedExam] = useState<string>("");
  const [examResult, setExamResult] = useState<ExamResult[]>([]);

  const errornotify = (msg: string) => toast.error(msg);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const response = await axios.get<Exam[]>(
          baseServiceUrl + urls.getAllExamUrl,
          {
            headers: {
              Authorization: "Bearer " + token,
            },
          }
        );
        if (response.data) {
          setList(response.data);
        }
        setLoading(false);
      } catch (err: any) {
        setLoading(false);
        errornotify(
          err?.response?.data?.message || "Error encountered. Please try again."
        );
      }
    })();
  }, [setLoading, token]);

  const handleExamChange = async (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const selectedId = event.target.value;
    setSelectedExam(selectedId);

    if (selectedId) {
      try {
        setLoading(true);
        const response = await axios.get<ExamResult[]>(
          `${baseServiceUrl}${urls.Examresult}/${selectedId}`,
          {
            headers: {
              Authorization: "Bearer " + token,
            },
          }
        );
        if (response.data) {
          setExamResult(response.data);
        }
        setLoading(false);
      } catch (err: any) {
        setLoading(false);
        errornotify(
          err?.response?.data?.message || "Error encountered. Please try again."
        );
      }
    }
  };

  return (
    <section
      id="sample-paper"
      className="flex flex-col items-center justify-center"
    >
      <div className="container w-full py-4 lg:w-[90%] md:w-[100%] mx-auto">
        <div className="bg-white rounded p-4 px-4 md:p-8 flex flex-col">
          <div className="flex flex-row items-center justify-between">
            <p className="text-2xl font-semibold mb-5">Select Exam</p>
          </div>
          <div className="mb-6">
            <select
              className="w-full p-2 border rounded"
              value={selectedExam}
              onChange={handleExamChange}
            >
              <option value="">Select an exam</option>
              {List.map((exam) => (
                <option key={exam.id} value={String(exam.id)}>
                  {exam.title}
                </option>
              ))}
            </select>
          </div>

          {examResult.length > 0 && (
            <>
              <div className="mb-4 p-4 border rounded bg-gray-100">
                <p>{examResult[0].title}</p>
              </div>

              <h3 className="text-xl font-semibold">Exam Result Details:</h3>
              <TableContainer component={Paper} className="mt-4">
                <Table>
                  <TableHead className="bg-gray-300 text-white">
                    <TableRow>
                      <TableCell align="center">User ID</TableCell>
                      <TableCell align="center">Full Name</TableCell>
                      <TableCell align="center">Email</TableCell>
                      <TableCell align="center">Phone</TableCell>
                      <TableCell align="center">Total Questions</TableCell>
                      <TableCell align="center">Total Marks</TableCell>
                      <TableCell align="center">Obtain Marks</TableCell>
                      <TableCell align="center">Correct Count</TableCell>
                      <TableCell align="center">Incorrect Count</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {examResult.map((result) => (
                      <TableRow key={result.user_id}>
                        <TableCell align="center">{result.user_id}</TableCell>
                        <TableCell align="center">{result.full_name}</TableCell>
                        <TableCell align="center">{result.email}</TableCell>
                        <TableCell align="center">{result.phone}</TableCell>
                        <TableCell align="center">
                          {result.total_questions}
                        </TableCell>
                        <TableCell align="center">
                          {result.total_marks}
                        </TableCell>
                        <TableCell align="center">
                          {result.obtain_masrk}
                        </TableCell>
                        <TableCell align="center">
                          {result.correct_count}
                        </TableCell>
                        <TableCell align="center">
                          {result.incorrect_count}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default ExamList;
